export default function reorderArray( arr, newOrder ) {
	return arr.map( ( d, i, a ) => a[ newOrder[ i ] ] );
}
